export type ManageRelationshipsMode =
  | { kind: 'submenu' }
  | { kind: 'direct'; pair: [string, string] }
  | { kind: 'hidden' };

export const hasDirectRelationship = (
  edges: { source: string; target: string }[],
  a: string,
  b: string,
): boolean =>
  edges.some(
    ({ source, target }) =>
      (source === a && target === b) || (source === b && target === a),
  );

export const getManageRelationshipsMode = (
  targetIds: string[],
  hasRelationship: (a: string, b: string) => boolean,
  hasRelations: boolean,
): ManageRelationshipsMode => {
  if (targetIds.length === 1) {
    return hasRelations ? { kind: 'submenu' } : { kind: 'hidden' };
  }

  if (targetIds.length === 2) {
    const [a, b] = targetIds;

    return hasRelationship(a, b)
      ? { kind: 'direct', pair: [a, b] }
      : { kind: 'hidden' };
  }

  return { kind: 'hidden' };
};
